module.exports = __webpack_public_path__ + "static/media/leak-pod-info-alert.598770da.svg";